import { render, staticRenderFns } from "./HeadComponent.vue?vue&type=template&id=01907b8c&scoped=true&"
import script from "./HeadComponent.vue?vue&type=script&lang=js&"
export * from "./HeadComponent.vue?vue&type=script&lang=js&"
import style0 from "./HeadComponent.vue?vue&type=style&index=0&id=01907b8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01907b8c",
  null
  
)

export default component.exports